import { dataLoaded, dataLoading } from 'app/modules/cms/service/store/cms-actions';
import { gtmEvent } from 'app/modules/gtm/service/gtm.service';
import { globalError, TYPE_ERROR } from 'app/shared/error/error-global';
import { translate } from 'react-jhipster';
import { corporateApi } from '../api';
import { ACTION_TYPES } from './store/corporate.actions';
import { Offer } from './store/corporate.state';

export const getSelectedOffer = (offerNumber: string) => async dispatch => {
  const result: any = await corporateApi.getSelectedOffer(offerNumber);

  if (result.isFailure) {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  const offer = result.getValue();

  const selectedOffer: Offer = {
    code: offer.code,
    title: offer.title,
    description: offer.description,
    showAmount: offer.showAmount,
    contribution: offer.contribution,
    IPIDUrl: 'http://IPID3',
    IPIDUrlTitle: translate('form.steps.offersOverview.documentLink'),
    covers: offer.coverItems,
    extras: offer.extraItems,
    badgeURL: offer.badgeURL,
    eurTaxInclAmount: offer.eurTaxInclAmount,
    coverTitle: offer.coverTitle,
    coverDetails: offer.coverDetails,
    extraTitle: offer.extraTitle,
    extraIconURL: offer.extraIconURL,
    extraDetails: offer.extraDetails,
    accessibility: offer.accessibility,
    documents: offer.documents
  };

  dispatch({
    type: ACTION_TYPES.SET_SELECTED_OFFER,
    payload: selectedOffer
  });
};

export const retrieveOffer = (prospection: any) => async dispatch => {
  await dispatch(dataLoading());
  const result: any = await corporateApi.retrieveOffer(prospection);
  const offer = result.getValue();

  const selectedOffer: Offer = {
    code: offer.code,
    title: offer.title,
    description: offer.description,
    showAmount: offer.showAmount,
    contribution: offer.contribution,
    IPIDUrl: 'http://IPID3',
    IPIDUrlTitle: translate('form.steps.offersOverview.documentLink'),
    covers: offer.coverItems,
    extras: offer.extraItems,
    badgeURL: offer.badgeURL,
    eurTaxInclAmount: offer.eurTaxInclAmount,
    coverTitle: offer.coverTitle,
    coverDetails: offer.coverDetails,
    extraTitle: offer.extraTitle,
    extraIconURL: offer.extraIconURL,
    extraDetails: offer.extraDetails,
    accessibility: offer.accessibility,
    documents: offer.documents
  };

  dispatch({
    type: ACTION_TYPES.SET_SELECTED_OFFER,
    payload: selectedOffer
  });
  await dispatch(dataLoaded());
};
export const getDocumentContent = (offerNumber: string, documentUuid: string, TypeName?: string) => async dispatch => {
  const result: any = await corporateApi.getDocumentContent(offerNumber, documentUuid);

  if (result.isFailure) {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  const url = window.URL.createObjectURL(new Blob([result.getValue()], { type: 'application/pdf' }));

  await dispatch({
    type: ACTION_TYPES.SET_DOC_URL,
    payload: { code: TypeName ? TypeName : offerNumber, docUrl: url }
  });
};

export const openPageMarketing = page => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.OPEN_PAGE_MARKETING,
    payload: { page }
  });
};

export const hidePageMarketing = () => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.HIDE_PAGE_MARKETING
  });
};

export const openDocument = (url, type) => async dispatch => {
  window.open(url);
  await dispatch(gtmEvent(type, 'pdf ' + type, '0'));
};

// isured goods
export const initializeInsuredGoods = () => async (dispatch, getState) => {
  const result = await corporateApi.getInsuredGoods();

  if (result.isFailure) {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  await dispatch({ type: ACTION_TYPES.INITIALIZE_INSUREDGOODS, payload: result.getValue() });

  const { contextSales, products } = await getState().corporate;

  // TODO: revoir la récupération des données du contexte
  if (contextSales !== undefined && contextSales.elementsGood !== undefined) {
    const _products = { ...products };

    (contextSales.elementsGood as any[]).forEach(el => {
      const goodIndex = _products.insuredGoods.findIndex(e => e.type.code === el.typeCode);

      const good = _products.insuredGoods[goodIndex];
      good.purchasePrice = {
        amount: el.purchasePrice,
        currency: el.currency,
        taxIncl: el.taxIncl
      };
      good.purchaseDate = el.purchaseDate;
    });

    await dispatch({ type: ACTION_TYPES.UPDATE_INSUREDGOODS_PURCHASE_DATE, payload: _products.insuredGoods });
  }
};

export const updateInsuredGood = (index, elementGood) => async dispatch => {
  await dispatch({ type: ACTION_TYPES.UPDATE_INSUREDGOOD, payload: { index, elementGood } });
};

export const updateInsuredGoodAmount = (index, amount) => async dispatch => {
  await dispatch({ type: ACTION_TYPES.UPDATE_INSUREDGOOD_AMOUNT, payload: { index, amount } });
};

export const updateInsuredGoodsPurchaseDate = insuredGoods => async dispatch => {
  await dispatch({ type: ACTION_TYPES.UPDATE_INSUREDGOODS_PURCHASE_DATE, payload: insuredGoods });
};

export const initHasFetchedOffer = () => async dispatch => {
  await dispatch({ type: ACTION_TYPES.INIT_HAS_FETCHED_OFFER });
};

export const setPayementError = (status, authorization) => async dispatch => {
  await dispatch({ type: ACTION_TYPES.UPDATE_PAYMENT_ERROR, payload: { status, authorization } });
};

export const sendEfirestMail = (email: string, code: string) => async dispatch => {
  const response = await corporateApi.sendEfirestMail(email, code);
  if (response.isSuccess) {
    dispatch({
      type: ACTION_TYPES.SET_EMAIL_SENDED
    });
  } else {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: response.errorValue() });
    return;
  }
};
